import type { LucideIcon } from 'lucide-react-native';
import {
  Stethoscope,
  Syringe,
  ShoppingBag,
  BedDouble,
  Package,
  Users,
  Zap,
  Wrench,
  Megaphone,
  Landmark,
  Building2,
  Percent,
  PlusCircle,
  RotateCcw,
  Banknote,
  MoreHorizontal,
  Scissors,
} from 'lucide-react-native';

import { colors } from '@/theme/tokens';

export interface CategoriaMeta {
  icon: LucideIcon;
  color: string;
  bgColor: string;
}

const META: Record<string, CategoriaMeta> = {
  Consulta:       { icon: Stethoscope, color: '#7B1F47', bgColor: '#FBE7F1' },
  Procedimiento:  { icon: Scissors,    color: '#A02862', bgColor: '#FCE8F2' },
  'Venta producto': { icon: ShoppingBag, color: '#0EA5E9', bgColor: '#E0F2FE' },
  Internación:    { icon: BedDouble,   color: '#0891B2', bgColor: '#CFFAFE' },
  Vacunación:     { icon: Syringe,     color: '#16A34A', bgColor: '#DCFCE7' },

  Insumos:        { icon: Package,     color: '#9333EA', bgColor: '#F3E8FF' },
  Salarios:       { icon: Users,       color: '#2563EB', bgColor: '#DBEAFE' },
  Servicios:      { icon: Zap,         color: '#D97706', bgColor: '#FEF3C7' },
  Mantenimiento:  { icon: Wrench,      color: '#475569', bgColor: '#E2E8F0' },
  Marketing:      { icon: Megaphone,   color: '#DB2777', bgColor: '#FCE7F3' },
  Impuestos:      { icon: Landmark,    color: '#B91C1C', bgColor: '#FEE2E2' },

  Alquiler:         { icon: Building2,  color: '#4F46E5', bgColor: '#E0E7FF' },
  Comisión:         { icon: Percent,    color: '#14B8A6', bgColor: '#CCFBF1' },
  'Aporte extra':   { icon: PlusCircle, color: '#22C55E', bgColor: '#DCFCE7' },

  Reembolso:    { icon: RotateCcw, color: '#F59E0B', bgColor: '#FEF3C7' },
  Liquidación:  { icon: Banknote,  color: '#0D9488', bgColor: '#CCFBF1' },

  Otro: { icon: MoreHorizontal, color: colors.ink[500], bgColor: colors.crema[100] },
};

const FALLBACK: CategoriaMeta = META.Otro;

export function categoriaMeta(nombre: string): CategoriaMeta {
  return META[nombre] ?? FALLBACK;
}
